import { render, staticRenderFns } from "./courseDetailWrap.vue?vue&type=template&id=1d136988&scoped=true"
import script from "./courseDetailWrap.vue?vue&type=script&lang=js"
export * from "./courseDetailWrap.vue?vue&type=script&lang=js"
import style0 from "./courseDetailWrap.vue?vue&type=style&index=0&id=1d136988&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d136988",
  null
  
)

export default component.exports